// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3oPXZ","right":"Footer_right__3LJIw","buttons":"Footer_buttons__F-RuC"};